import { render, staticRenderFns } from "./CustomDetail.vue?vue&type=template&id=3513badc&scoped=true&"
import script from "./CustomDetail.vue?vue&type=script&lang=js&"
export * from "./CustomDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomDetail.vue?vue&type=style&index=0&id=3513badc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513badc",
  null
  
)

export default component.exports